import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
  Row,
} from "reactstrap"
import * as Yup from "yup"
import DeleteModel from "common/deleteModel/deleteModel"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import { useFormik } from "formik"
import WorkersTable from "./WorkersTable"
import { UnBillsType } from "_mock/Static_data"
import { exportDataExcel } from "components/Common/ExportData"
import { dateFormat } from "pages/Common"

function Workers() {
  document.title = `Workers | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()
  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState("")
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [workerId, setWorkerId] = useState(0)
  const [transactionData, setTransactionData] = useState([])
  const [transactionModal, setTransactionModal] = useState(false)
  const [isActive, setIsActive] = useState(true)

  // worker list api
  const workerApi = () => {
    setScreenLoad(true)
    setIsLoading(true)
    getApi(`Common/worker/list?isActive=${isActive}`).then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false)
        setTableData(data)
        setTotalRecords(data.length)
      } else {
        setIsLoading(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setScreenLoad(false)
    })
  }

  // worker list api useEffect
  useEffect(() => {
    workerApi()
  }, [isActive])

  // toggle handlers
  const toggle = () => {
    setModal(!modal)
    validation.handleReset()
  }

  const toggleTransaction = () => {
    setTransactionModal(!transactionModal)
  }


  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  // Delete worker handler
  const handleDelete = workerId => {
    setScreenLoad(true)
    if (workerId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this worker permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`Common/worker/delete?Id=${workerId}`).then(
            ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== workerId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("successfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Worker",
                  text: data,
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  // Update worker handler
  const handleEditWorker = workerdata => {
    if (workerdata) {
      setWorkerId(workerdata.Id)
      setIsEdit(true)
      setModal(!modal)
      setEditData(workerdata)
    }
  }

  // Create worker handler
  const handleWorkerClick = () => {
    setIsEdit(false)
    toggle()
  }

  // Workers Validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Name: isEdit ? editData?.Name : "",
      Cost: isEdit ? editData?.Cost : '',
    },
    validationSchema: Yup.object({
      Name: Yup.string().required("The name is required"),
      Cost: Yup.string().required("The cost is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      if (values) {
        postApi("Common/worker/addedit", {
          id: isEdit ? parseInt(workerId) : 0,
          Name: values.Name,
          Cost: parseFloat(values.Cost || 0) || 0,
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status == 400) {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            toast.success(isEdit ? "successfully updated" : "successfully created", {
              style: {
                fontSize: "15px",
              },
            })
            toggle()
            workerApi()
            validation.handleReset()
          }
        })
      }
    },
  })

  const handleSwitch = (id, IsActive, e) => {
    if (id) {
      putApi("Common/worker/active-inacive", { id: String(id) }).then(({ data, status }) => {
        e.preventDefault()
        if (status === 200) {
          toast.success("worker sucessfully changed", {
            style: {
              fontSize: "15px",
            },
          })
        } else {
          $("#IsActive_" + id + "").prop("checked", IsActive)
          ErrorModel.errormodel({
            title: "Verify Worker",
            text: data,
          })
        }
      })
    }
  }

  // Worker table header & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Cost",
        Header: () => (
          <div
            style={{
              textAlign: "right",
            }}
          >
            Cost
          </div>
        ),
        accessor: "Cost",
        width: "10%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}>
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.Cost || 0)}
            </div>
          )
        },
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Is Active
          </div>
        ),
        width: "7%",
        accessor: "IsActive",
        disableSorting: true,
        Cell: ({ row }) => (
          <FormGroup switch className="d-flex justify-content-center">
            <Input
              type="switch"
              id={`IsActive_${row.original.Id}`}
              disabled={row.original.IsRetire == true}
              defaultChecked={row.original.IsActive}
              onClick={e => {
                handleSwitch(row.original.Id, row.original.IsActive, e)
              }}
            />
          </FormGroup>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "6%",
        accessor: "action",
        width: "8%",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditWorker(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  id={`deletetooltip${row.original.Id}`}
                  className="fs-6 fas fa-trash-alt btn-delete"
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  const transactioncolumns = useMemo(
    () => [
      {
        Header: "Created On",
        accessor: "CreatedOn",
        width: "10%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.CreatedOn == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: "Paid Amt.",
        accessor: "PaidAmount",
        width: "7%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}>
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.PaidAmount || 0)}
            </div>
          )
        },
      },
      {
        Header: "Payment Mode",
        accessor: "PaymentMode",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <>
              <div>
                {row.original.PaymentMode == 1 ? "Cash" : "Bank"}
              </div>
            </>
          )
        },
      },
      {
        Header: "Created By",
        accessor: "CreatedByName",
        width: "10%"
      },
      {
        Header: "Remark",
        accessor: "Remark",
        Cell: ({ row }) => {
          return (
            <>
              <div style={{ textWrap: "wrap" }}>
                {row.original.Remark == null || row.original.Remark == '' ? "N/A" : row.original.Remark}
              </div>
            </>
          )
        },
      },
    ],
    [transactionData]
  )

  function writeDataToExcel() {
    setIsLoading(true)
    let header = ["Name"];
    const mainTitle = "Workers";
    const widthObj = [{
      Key: "A",
      Value: 30,
    },
    {
      Key: "B",
      Value: 18,
    },
    ]
    const extention = "Workers.xlsx"
    let excelSheetData = []
    for (let index = 0; index < tableData.length; index++) {
      let dataObj = {
        Name: tableData[index].Name,
      }
      excelSheetData.push(dataObj)
    }
    var fields = Object.keys(excelSheetData[0]);
    var sheetData = excelSheetData.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName];
      });
    });
    setIsLoading(false)
    sheetData.unshift(header);
    exportDataExcel(sheetData, mainTitle, widthObj, extention)
  }

  const handleKeyPress = event => {
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <WorkersTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isCategoryList={true}
              handleWorkerClick={handleWorkerClick}
              customPageSize={10}
              className="custom-header-css"
              isLoading={isLoading}
              TotalRecords={totalRecords}
              writeDataToExcel={writeDataToExcel}
              setIsActive={setIsActive}
              isActive={isActive}
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: !isMobile ? "350px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update Worker" : "Create Worker"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <Row>
                      <FormGroup className="mb-2">
                        <Label htmlFor="validationCustom03" className="required">
                          Name
                        </Label>
                        <Input
                          name="Name"
                          placeholder="Worker Name"
                          type="text"
                          className="form-control-sm"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.Name || ""}
                          invalid={
                            validation.touched.Name && validation.errors.Name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.Name && validation.errors.Name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.Name}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Row>
                    <Row>
                      <FormGroup className="mb-2">
                        <Label htmlFor="validationCustom03" className="required">
                          Cost
                        </Label>
                        <Input
                          name="Cost"
                          placeholder="0"
                          type="text"
                          className="form-control-sm"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          onKeyPress={handleKeyPress}
                          value={validation.values.Cost || ""}
                          invalid={
                            validation.touched.Cost && validation.errors.Cost
                              ? true
                              : false
                          }
                        />
                        {validation.touched.Cost && validation.errors.Cost ? (
                          <FormFeedback type="invalid">
                            {validation.errors.Cost}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Row>

                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm"
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      <>
                        {formSumitLoading ? (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </button>
                        ) : (
                          <Button
                            color="primary"
                            className="btn btn-primary btn-sm "
                            type="submit"
                          >
                            Submit
                          </Button>
                        )}
                      </>
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </div>
    </div >
  )
}
Workers.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Workers